// Type definitions for runtime configuration
declare global {
  interface Window {
    APP_CONFIG?: AppConfigType;
  }
}

export interface AppConfigType {
  API_BASE_URL: string;
  API_TIMEOUT: string;
  AI_ASSISTANT_ENABLED: string;
  BASE_PATH: string;
}

class AppConfig {
  private static instance: AppConfig;

  private constructor() {
    // Private constructor for singleton pattern
  }

  public static getInstance(): AppConfig {
    if (!AppConfig.instance) {
      AppConfig.instance = new AppConfig();
    }
    return AppConfig.instance;
  }

  private getEnv(env: keyof AppConfigType, defaultValue: string = ''): string {
    // 1. Try runtime config from window.APP_CONFIG (only if not a template placeholder)
    const runtimeValue = window.APP_CONFIG?.[env];
    if (runtimeValue && runtimeValue !== `\${${env}}`) {
      return runtimeValue;
    }

    // 2. Try build-time environment variables (VITE_ prefix) for development
    const devValue = import.meta.env[`VITE_${env}`];
    if (devValue) {
      return devValue;
    }

    // 3. Use default value
    return defaultValue;
  }

  public getApiBaseURL(): string {
    return this.getEnv('API_BASE_URL', 'http://localhost:8181/accounting-api');
  }

  public getApiRequestTimeout(): number {
    return Number(this.getEnv('API_TIMEOUT', '2000'));
  }

  /** Whether the assistant widget is shown. Off unless AI_ASSISTANT_ENABLED is exactly 'true'. */
  public isAssistantEnabled(): boolean {
    return this.getEnv('AI_ASSISTANT_ENABLED', 'false') === 'true';
  }

  public getBasePath(): string {
    return this.getEnv('BASE_PATH', '');
  }
}

// Export singleton instance
const appConfig = AppConfig.getInstance();
export default appConfig;
